





















import Person from '@/types/Person.interface'
import PersonsAutocomplete from '@/components/PersonsAutoComplete.vue'
import Vue from 'vue'
export default Vue.extend({
    components: { PersonsAutocomplete },
    methods: {
        submitPerson(person: Person): void {
            this.$emit('submit', person)
        }
    }
})
